import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../../api.service';
import { ProfileRefreshService } from './profile-refresh.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, OnDestroy {

  readonly circumference = 2 * Math.PI * 52;   // ring ka size (svg r=52)
  steps: any[] = [];
  loaded = false;
  private sub: Subscription | undefined;

  constructor(private apiService: ApiService, private refresh: ProfileRefreshService) {}

  ngOnInit(): void {
    this.load();
    // child page save kare to completion dubara calculate ho
    this.sub = this.refresh.changes$.subscribe(() => this.load());
  }

  load() {
    const id = Number(localStorage.getItem('user_id'));
    if (!id) { return; }

    this.apiService.getUserById(id).subscribe(
      (response: any) => {
        const u = response?.Users || {};
        const has = (v: any) => v !== null && v !== undefined && String(v).trim() !== '';

        this.steps = [
          { label: 'Profile Photo',      link: '/profile/basic-information', done: has(u.profile_image) || has(u.profile) },
          { label: 'Basic Information',  link: '/profile/basic-information', done: has(u.firstname) && has(u.lastname) && (has(u.city) || has(u.country)) },
          { label: 'Work & Business',    link: '/profile/work-and-social',   done: has(u.company) || has(u.job_title) },
          { label: 'Social Media',       link: '/profile/work-and-social',   done: ['facebook_url', 'twitter_url', 'linkedin_url', 'youtube_url'].some(k => has(u[k])) },
          { label: 'Apply for Referral', link: '/profile/apply-for-referral', done: has(u.refer_code) }
        ];
        this.loaded = true;
      },
      () => { /* completion card optional hai, error par chup rehna theek hai */ }
    );
  }

  get percent(): number {
    if (!this.steps.length) { return 0; }
    return Math.round((this.steps.filter(s => s.done).length / this.steps.length) * 100);
  }

  get dashOffset(): number {
    return this.circumference * (1 - this.percent / 100);
  }

  get nextStep(): any {
    return this.steps.find(s => !s.done);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
